/**
 * Market Field Component
 * Dropdown for market (ANZ/USA) filter
 */

import React from 'react'
import { FormControl, Select, MenuItem, Typography, Box, SelectChangeEvent } from '@mui/material'
import { getMarketFilterOptions } from '../../../../constants/markets'

interface MarketFieldProps {
  value: string
  onChange: (value: string) => void
  label?: string
}

const labelStyle = {
  fontWeight: 600,
  color: 'text.secondary',
  fontSize: '0.75rem',
  mb: 0.5,
  display: 'block',
}

const MarketField: React.FC<MarketFieldProps> = ({
  value,
  onChange,
  label = 'Market',
}) => {
  const marketOptions = getMarketFilterOptions()

  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value)
  }

  return (
    <Box>
      <Typography component="label" sx={labelStyle}>
        {label}
      </Typography>
      <FormControl fullWidth size="small">
        <Select displayEmpty value={value} onChange={handleChange}>
          <MenuItem value="">All Markets</MenuItem>
          {marketOptions
            .filter((opt) => opt.value !== '')
            .map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default MarketField
